import {
	Card,
	CardBody,
	CardFooter,
	Content,
	ContentVariants,
	Flex,
	FlexItem,
	Grid,
	GridItem,
	Progress,
	ProgressMeasureLocation,
	Truncate,
} from "@patternfly/react-core";
import { listingTypeOptions } from "../../../../constants/products";
import { calculateLocalProductScore, getTypeNameWithIcon } from "../../../../utils/productListUtils";
import "./ProductCard.scss";
import { useQueryClient } from "@tanstack/react-query";
import type { IActiveProductDetails, IProductListDetails } from "../../../../constants/apiconstants-pyxis";
import Env from "../../../../utils/env";
import { AddProductInfoCard } from "./General/AddProductInfoCard";

const UnfinishedProductCard = () => {
	const unfinishedProducts = useQueryClient().getQueryData<IActiveProductDetails>(["productList"])?.data
		?.unfinishedProducts;
	return (
		<div className="products">
			<Content>
				<Content className="products__heading" component={ContentVariants.h3}>
					Finish your product listing
				</Content>
			</Content>
			<Grid hasGutter>
				{unfinishedProducts?.data?.map((unpublishedProduct: IProductListDetails) => {
					const typeName =
						listingTypeOptions.find((option) => unpublishedProduct.type && option.value === unpublishedProduct.type)
							?.header || "";
					const { productScorePercentage } = calculateLocalProductScore(unpublishedProduct);
					return (
						<GridItem lg={4} md={4} sm={12} key={unpublishedProduct?._id}>
							<Card
								className="products__card"
								component="a"
								href={`${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products/${unpublishedProduct?._id}`}
								isFullHeight
							>
								<CardBody isFilled>
									<Flex
										alignItems={{ default: "alignItemsFlexStart" }}
										justifyContent={{ default: "justifyContentSpaceBetween" }}
									>
										<FlexItem>
											<Content className="products__card__description">
												<Content className="products__card__description__type" component="p">
													{typeName}
												</Content>
												<Content component="h4">
													<Truncate content={unpublishedProduct?.name} />
												</Content>
											</Content>
										</FlexItem>
										<FlexItem>
											<div className="products__card__type-icon">{getTypeNameWithIcon(unpublishedProduct.type)}</div>
										</FlexItem>
									</Flex>
								</CardBody>
								<CardFooter>
									<Progress
										aria-label={`${productScorePercentage} complete`}
										value={productScorePercentage}
										measureLocation={ProgressMeasureLocation.none}
									/>
									<Content>
										<Content component="p">{productScorePercentage}% complete</Content>
									</Content>
								</CardFooter>
							</Card>
						</GridItem>
					);
				})}
				{unfinishedProducts?.data?.length === 1 && (
					<GridItem span={8}>
						<AddProductInfoCard heading="Grow your product listings" />
					</GridItem>
				)}
				{unfinishedProducts?.data?.length === 0 && (
					<GridItem span={8}>
						<AddProductInfoCard heading="There are no unpublished product listings" />
					</GridItem>
				)}
			</Grid>
		</div>
	);
};

export default UnfinishedProductCard;
